// /Users/huyanlin/WebstormProjects/swyl-web/src/api/guanhuai/cluePlatformOwner.js
import http from '../../../utils/fetch';

export default {

    baseurl: '/api/swyl/v1/demo/bscPalletDealer',

    selectPage(query) {
        return http({
            url: this.baseurl + '/selectPage',
            method: 'post',
            params: query
        });
    },

    insert(query) {
        return http({
            url: this.baseurl + '/insert',
            method: 'post',
            params: query
        });
    },

    updateById(query) {
        return http({
            url: this.baseurl + '/updateById',
            method: 'post',
            params: query
        });
    },

    deleteById(query) {
        return http({
            url: this.baseurl + '/deleteById',
            method: 'post',
            params: query
        });
    }
};
